module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot7-d14d4ac1ac6415d72078f7b0511efc5e.png";